import axios from "axios";
import { setupCache } from "axios-cache-adapter";
import common from "./common";

// Create `axios-cache-adapter` instance
const cache = setupCache({
  maxAge: 15 * 60 * 1000
});
var commonModule = new common();
export const HTTP = axios.create({
  headers: {
    "Content-Type": "application/json",
    token: commonModule.getAuthToken()
  },
  adapter: cache.adapter
});
var authorizationData = commonModule.getAuthToken();
if (authorizationData == "") {
  // remove cookies
  commonModule.removeAuthToken();
  commonModule.removeLocalizedData();
  commonModule.removeUserName();
  window.location.href = "#/login";
}

HTTP.interceptors.request.use(
  function(request) {
    var authToken = commonModule.getAuthToken();
    // not authorized then navigate to login page
    if (authToken == null || authToken == "") {
      window.location.href = "#/login";
    } else {
      request.headers.token = authToken;
      return Promise.resolve(request);
    }
  },
  function(error) {
    commonModule.stopLoading();
    // check if unauthorized error returned
    // request is rejected and will direct logic to the catch() method
    return Promise.reject(error);
  }
);

HTTP.interceptors.response.use(
  function(response) {
    // 瀏覽器緩存機制--版本對比
    // let v = response.headers['vers'] || 'default'
    // if (v !== localStorage.getItem('vers') && response.config.method == 'get') {
    //   localStorage.setItem('vers', v)
    //   window.location.reload() // 对于新版本，只需在任何 get 上重新加载
    // }
    return Promise.resolve(response);
  },
  function(error) {
    console.dir(error, "--------error");
    if (error.message === "Network Error") {
      return Promise.reject({
        IsSuccess: false,
        Message: error.message,
        Token: null,
        Data: null
      });
    } else if (
      error.response.status == 401 &&
      commonModule.getStayLoggedIn() == "true"
    ) {
      //call refresh token API
      refreshToken(error.response.config);
    } else if (
      error.response.status == 401 &&
      commonModule.getStayLoggedIn() == "false"
    ) {
      commonModule.removeAuthToken();
      commonModule.stopLoading();
      window.location.href = "#/login";
    }
    // request is rejected and will direct logic to the catch() method
    return Promise.reject(error);
  }
);

function refreshToken(previousRequest) {
  commonModule.startLoading();

  return new Promise((resolve, reject) => {
    HTTP.post(`${commonModule.baseURL}/authentication/reauthenticatetoken`)
      .then(response => {
        //replace token and call API again
        commonModule.setAuthToken(response.data.Data.AccessToken);
        resolve(response);
        return new Promise((resolve, reject) => {
          HTTP.post(previousRequest.url, previousRequest.data)
            .then(response => {
              resolve(response);
              commonModule.stopLoading();
              //reload page
              window.location.reload();
            })
            .catch(e => {
              reject(e);
              commonModule.removeAuthToken();
              commonModule.stopLoading();
              window.location.href = "#/login";
            });
        });
      })
      .catch(e => {
        reject(e);
        if (e.response.status == 401) {
          commonModule.stopLoading();
          //if API returns 401 redirect to login page
          commonModule.removeAuthToken();
          window.location.href = "#/login";
        }
        return Promise.reject(e);
      });
  });
}
